import { openBlock, createElementBlock, createElementVNode } from "vue";
import { _ as _export_sfc } from "./index-nOmQweDK.mjs";
const _sfc_main = {};
const _hoisted_1 = /* @__PURE__ */ createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2Z",
  fill: "#FC4420"
}, null, -1);
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M10.8821 10.1004C10.814 10.0002 10.7905 9.91703 10.7905 9.8309C10.7905 9.4082 11.3031 9.30652 11.985 9.30652C13.0787 9.30652 13.8996 9.7093 14.3542 9.7093C15.0077 9.7093 15.4144 9.27202 15.4144 8.68546C15.4144 8.30837 15.2954 8.01512 15.0539 7.77773C14.4288 7.16319 12.8373 7 12.0561 7C9.79731 7 8.21313 8.09014 8.21313 9.86378C8.21313 12.954 12.2825 12.8187 13.2059 13.6845C13.3195 13.7962 13.3906 13.8997 13.3906 14.0812C13.3906 14.4613 12.9847 14.6438 12.1263 14.6438C10.565 14.6438 9.68112 13.9005 9.05657 13.9005C8.40308 13.9005 8 14.4304 8 15.0448C8 16.3855 10.2803 17 11.8714 17C14.1585 17 16 16.0085 16 13.8997C16 10.7265 11.9464 11.0165 11.0325 10.2561C10.9669 10.2045 10.9176 10.1528 10.8821 10.1004Z",
  fill: "white"
}, null, -1);
const _hoisted_3 = [
  _hoisted_1,
  _hoisted_2
];
function _sfc_render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    onClick: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("click", $event))
  }, _hoisted_3);
}
const icV2StoveSymbolColor = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);
export {
  icV2StoveSymbolColor as default
};
